import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_POINT,
  FETCH_POINT_LOG,
  M_POST,
  FETCH_LOTTO,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'point' })
export default class Point extends VuexModule {
  @Action
  async FetchPointReport(user: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_POINT,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FetchPointLog(user: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_POINT_LOG,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FetchLotto(date: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_LOTTO,
      data: date,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
